<template>
  <fragment>
    <form @submit.prevent="loadData(false)">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <span class="label">조회기간</span>
            <div class="cell">
              <PeriodPicker
                :startDate="$utils.calcDate(null, '-7d')"
                :minDate="new Date('2019')"
                :maxDate="new Date()"
                maxPeriod="6m"
                @maxPeriodError="onMaxPeriodError($refs.PeriodPicker)"
                ref="PeriodPicker"
              />
            </div>
            <div class="cell">
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- 테이블 -->
    <PagingTable ref="table" :sourceList="tableItems">
      <template #header>
        <caption>
          <span class="blind">소식관리 목록</span>
        </caption>
        <colgroup>
          <col width="15%" />
        </colgroup>

        <thead class="table_list_head table_list_head_line">
          <tr>
            <th class="center" rowspan="2">날짜</th>
            <th class="center" colspan="2">일반소식</th>
            <th class="center" colspan="2">반복소식</th>
            <th class="center">맞춤소식</th>
            <th class="center" colspan="3">두뇌톡톡</th>
            <th class="center" colspan="2">기억검사</th>
            <th class="center">좋은생각</th>
            <th class="center">마음체조</th>
          </tr>
          <tr>
            <th class="center">전송</th>
            <th class="center">확인</th>
            <th class="center">전송</th>
            <th class="center">확인</th>
            <th class="center">전송</th>
            <th class="center">평균점수</th>
            <th class="center">호출</th>
            <th class="center">완료</th>
            <th class="center">호출</th>
            <th class="center">완료</th>
            <th class="center">호출</th>
            <th class="center">호출</th>
          </tr>
        </thead>
      </template>
      <template #row="{ rowData }">
        <tr>
          <td>{{rowData.date}}</td>
          <td class="right">{{rowData.newsNormalRequestCount}}</td>
          <td class="right">{{rowData.newsNormalReadCount}}</td>
          <td class="right">{{rowData.newsRepeatRequestCount}}</td>
          <td class="right">{{rowData.newsRepeatReadCount}}</td>
          <td class="right">{{rowData.newsCustomRequestCount}}</td>
          <td class="right">{{rowData.gameAvgScore}}</td>
          <td class="right">{{rowData.gameStartCount}}</td>
          <td class="right">{{rowData.gameFinalCount}}</td>
          <td class="right">{{rowData.dementiaStartCount}}</td>
          <td class="right">{{rowData.dementiaFinalCount}}</td>
          <td class="right">{{rowData.goodStartCount}}</td>
          <td class="right">{{rowData.mindStartCount}}</td>
        </tr>
      </template>
    </PagingTable>

    <div class="section_button none_paginate">
      <ExcelDownloadButton :filename="$utils.excelName('대상자상세', '이용통계', rcpDetail.rcpName)">
        <ExcelTable :sourceList="tableItems" />
      </ExcelDownloadButton>
      <HelpButton contentId="HELP_07" />
    </div>
  </fragment>
</template>

<script>
import periodPickerMixin from "$mixins/periodPicker";
import ExcelTable from "./Detail.daily.excel";

export default {
  mixins: [periodPickerMixin],
  components: { ExcelTable },
  props: {
    rcpDetail: Object
  },
  data() {
    const rcpId = this.$route.params.id;
    return {
      rcpId,
      tableItems: null,
      formData: {
        rcpId,
        searchDateFrom: "",
        searchDateTo: ""
      }
    };
  },
  methods: {
    requestOptions() {
      const period = this.$refs.PeriodPicker.getData();

      return {
        params: _.merge(this.formData, {
          searchDateFrom: this.$utils.dateText(period.startDate, ""),
          searchDateTo: this.$utils.dateText(period.endDate, "")
        })
      };
    },
    loadData(keepTableState) {
      const options = this.requestOptions();
      this.$axios
        .get("/admin/happy/stats/v2/user/daily", options)
        .then(({ data }) => {
          this.tableItems = data.userDailyUseDataList;
          if (!keepTableState) this.$refs.table.resetState();
        });
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style>
</style>